import React from 'react'
import Styles from './sidebar.module.css'
import { NavLink } from "react-router-dom";
import NavItem from '../Nav'
import jwt_decode from "jwt-decode";
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { RxHamburgerMenu } from "react-icons/rx";


function Sidebar(props) {
    const { isSidebar, toggleSideBar } = props;
    const accessCokies = useSelector(state => state.loginSlice)
    const user = !isEmpty(accessCokies.token) ?  jwt_decode(accessCokies.token) : {accessLevel: 0}
    return (
       <>
        <div className={Styles.sidebar}>
                <div className={Styles.logo}>
                    {/* <RxHamburgerMenu size={30} onClick={toggleSideBar}></RxHamburgerMenu> */}
                <img src='https://gameex.com/new_script/img/logo.png' alt='' />
                </div>
                
                
                <div className={Styles.navContainer}>
           {
                        NavItem.map((data, index) => user.accessLevel >= data.access_level ?
                            <div key={index} className={Styles.oneitem} >
                        <div className={Styles.singleitem} >
                                    <NavLink className={Styles.anchorTag} exact={true}
                                        onMouseEnter={(e) => e.target.style.background = "#afafaf"}
                                        onMouseLeave={(e)=>e.target.style.background = "#f2f2f2"}
                                to={{pathname: data.path}}
                            >{data.icon} {data.title}</NavLink>
                        </div>
                    </div> : ''
                )
            }
           </div>
        </div>
       </>
    )
}

export default Sidebar